import React from "react";
import { Col, Row } from "react-bootstrap";
import "./ScoreboardImage.css";

type Props = {};
type State = {
image:any
};
export class ScoreboardImage extends React.Component<Props, State> {
	
	constructor(props: Props) {
		super(props);
		this.state = {image: ""};
	}

	componentDidMount() {
		const params = new URLSearchParams(window.location.search);
		const url = params.get("url");
		console.log(url);
		this.setState({image:url});

		
	}
	
	render() {
		return (
			<div id="scoreboard-wrapper" style={{textAlign: "center", width:576, height:432}}>
				<Row style={{width:576,height:432, position:"absolute", top:0, left:0}}>
					<Col><img src={this.state.image} height="432" width="576"/></Col>
					</Row>	
			</div>
		);
	}
}